"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, useIsLessThanLg } from "@opensea/ui-kit";
import { HeroBannerMedia } from "./HeroBannerMedia";
import { HeroHeaderLayout } from "./HeroHeaderLayout";
import { HeroHeaderProvider } from "./HeroHeaderProvider";
import { useHeroHeaderView } from "./HeroHeaderViewProvider";
export function HeroHeader(t0) {
  const $ = _c(38);
  let children;
  let fallbackImageUrl;
  let isCollectionBanner;
  let mediaFormat;
  let mediaUrl;
  let ref;
  let rest;
  if ($[0] !== t0) {
    ({
      fallbackImageUrl,
      mediaUrl,
      children,
      isCollectionBanner,
      mediaFormat,
      ref,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = fallbackImageUrl;
    $[3] = isCollectionBanner;
    $[4] = mediaFormat;
    $[5] = mediaUrl;
    $[6] = ref;
    $[7] = rest;
  } else {
    children = $[1];
    fallbackImageUrl = $[2];
    isCollectionBanner = $[3];
    mediaFormat = $[4];
    mediaUrl = $[5];
    ref = $[6];
    rest = $[7];
  }
  const {
    headerView,
    headerViewScrollLocked
  } = useHeroHeaderView();
  const isMobile = useIsLessThanLg();
  const t1 = isMobile && "dark -mx-4 bg-bg-app px-4";
  let t2;
  if ($[8] !== t1) {
    t2 = classNames(t1);
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== fallbackImageUrl || $[11] !== headerView || $[12] !== mediaFormat || $[13] !== mediaUrl) {
    t3 = <HeroBannerMedia className="z-10" fallbackImageUrl={fallbackImageUrl} headerView={headerView} mediaFormat={mediaFormat} mediaUrl={mediaUrl} />;
    $[10] = fallbackImageUrl;
    $[11] = headerView;
    $[12] = mediaFormat;
    $[13] = mediaUrl;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const t4 = headerView === "compact" ? "opacity-20" : "opacity-0";
  let t5;
  if ($[15] !== t4) {
    t5 = classNames("fixed top-0 z-0", t4);
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== fallbackImageUrl || $[18] !== mediaFormat || $[19] !== mediaUrl || $[20] !== t5) {
    t6 = <HeroBannerMedia blur={true} className={t5} fallbackImageUrl={fallbackImageUrl} headerView="compact" mediaFormat={mediaFormat} mediaUrl={mediaUrl} />;
    $[17] = fallbackImageUrl;
    $[18] = mediaFormat;
    $[19] = mediaUrl;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t3 || $[23] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== children || $[26] !== headerView || $[27] !== headerViewScrollLocked || $[28] !== isCollectionBanner || $[29] !== t7) {
    t8 = <HeroHeaderLayout headerView={headerView} headerViewScrollLocked={headerViewScrollLocked} isCollectionBanner={isCollectionBanner} media={t7}>{children}</HeroHeaderLayout>;
    $[25] = children;
    $[26] = headerView;
    $[27] = headerViewScrollLocked;
    $[28] = isCollectionBanner;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== ref || $[32] !== t8) {
    t9 = <div ref={ref}>{t8}</div>;
    $[31] = ref;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== rest || $[35] !== t2 || $[36] !== t9) {
    t10 = <HeroHeaderProvider><div className={t2} id="hero-header" {...rest}>{t9}</div></HeroHeaderProvider>;
    $[34] = rest;
    $[35] = t2;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}